import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { ListStores } from '../../FormControls/ListAllStores';
import {
  getListStores,
} from "../../../../main/slices/storeSlice";
import { LoadingComponent } from '../../LoadingComponent';

export const StoresList = ({ dimensions }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [stores, setStores] = useState([]);
    const wld = useSelector(({ user }) => user.idWLD);
    const email = useSelector(({ user }) => user.email.value);
    
    const getAllStoresUser = async () => {
        await dispatch(getListStores({
            "origin": "worldpos",
            "wldId": `${wld}`,
            "email": `${email}`
        }))
        .unwrap()
        .then(({ response }) => {
            if (response.code==200) {
                setStores(response.data); 
            };
            setLoading(false);
        })
        .catch(e => false);
    }

    useEffect(() => {
        getAllStoresUser();
    }, [dispatch]);

    
    if(loading){
        return (
            <Fragment>
                <LoadingComponent />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div style={{ padding: "0 0.1rem" }}>
                <ListStores items={stores} />
            </div>
        </Fragment>
    )
}